
import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/lib/supabase';
import { useState } from 'react';

export function usePlaylistData(playlistId: string) {
  return useQuery({
    queryKey: ['playlist', playlistId],
    queryFn: async () => {
      const { data, error } = await supabase
        .from('destination_playlists')
        .select('*')
        .eq('id', playlistId)
        .single();
      
      if (error) throw error;
      return data;
    }
  });
}

export interface SimilarPlace {
  id: string;
  name: string;
  place_type?: string;
  address?: string;
  url?: string;
  photos?: string[];
  price_range?: string;
  requires_reservation?: boolean;
  city?: string;
  country?: string;
  note?: string;
  cuisine_type?: string;
  rating?: number;
  amenities?: string[];
  accessibility_features?: string[];
  best_time_to_visit?: string;
  tags?: string[];
}

export function useSimilarPlaceCheck() {
  const [isSearching, setIsSearching] = useState(false);
  const [similarPlace, setSimilarPlace] = useState<SimilarPlace | null>(null);

  const checkSimilarPlace = async (name: string, address: string | null) => {
    if (!name) return null;
    setIsSearching(true);
    
    try {
      const { data, error } = await supabase
        .rpc('find_similar_places', { 
          place_name: name,
          place_address: address || ''
        });
        
      if (error) throw error;
      
      const foundPlace = data && data.length > 0 ? data[0] : null;
      setSimilarPlace(foundPlace);
      return foundPlace;
    } catch (error) {
      console.error('Error finding similar places:', error);
      setSimilarPlace(null);
      return null;
    } finally {
      setIsSearching(false);
    }
  };

  return {
    isSearching,
    similarPlace,
    checkSimilarPlace,
    clearSimilarPlace: () => setSimilarPlace(null)
  };
}
